var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"content"},[_c('h2',[_vm._v("PRIVATE NURSE")]),_c('h4',[_vm._v("A licensed nurse providing close observation and performing special treatments, which are certified as Medically Necessary by the Attending Physician.")])])
}]

export { render, staticRenderFns }